export const housekeepingDrawer = {
  close: "Fermer",
  guest: "Client",

  cleaning: {
    title: "État du ménage",
    lastCleaned: "Nettoyé le {date}",
    evidenceAlt: "preuve",
  },

  status: {
    dirty: "À nettoyer",
    in_progress: "En cours",
    clean: "Propre",
    inspected: "Inspecté",
    out_of_service: "Hors service",
  },

  occupancy: {
    title: "Occupation",
    aboutToLeave: "Sur le point de partir",
    checkIn: "Arrivée le {date}",
    checkOut: "Départ le {date}",
    checkoutTime: "Départ à {time}",
    booking: "Réservation {code}",
    nextArrivalToday: "Prochaine arrivée aujourd'hui",
    fromTime: "à partir de {time}",
    labels: {
      vacant: "Libre",
      occupied: "Occupé",
      departure_today: "Départ aujourd'hui",
      arrival_today: "Arrivée aujourd'hui",
      turnover: "Départ et arrivée aujourd'hui",
    },
  },

  window: {
    windowLabel: "Créneau",
    standardSchedule: "Horaire standard",
    sub: "{label} : départ {checkout} → arrivée {checkin}",
    overdue: "Arrivée en retard · priorisez ce ménage",
    untilArrival: "{dur} avant l'arrivée",
  },

  tasks: {
    title: "Tâches de ménage",
    // Pluralization (vue-i18n v8 pipes) — choiceIndex = number of open tasks
    pendingCount: "{count} en attente | {count} en attente",
    newPlaceholder: "Ajouter une tâche (ex. Changer les serviettes)",
    priorityTitle: "Priorité",
    dateTitle: "Date",
    timeTitle: "Heure (facultatif)",
    assignTitle: "Attribuer à",
    assignAllOption: "Tout le monde (ménage et maintenance)",
    byRole: "Par rôle",
    wholeRoleSuffix: "(rôle entier)",
    people: "Personnes",
    add: "Ajouter",
    adding: "Ajout…",
    loading: "Chargement des tâches…",
    empty: "Aucune tâche. Ajoutez la première ci-dessus.",
    markPending: "Marquer comme en attente",
    markDone: "Marquer comme terminée",
    priorityDotTitle: "Priorité {priority}",
    delete: "Supprimer",
  },

  enc: {
    late: "Overdue",
    title: "Requests for this room",
    what: "One-off things besides the cleaning: restock something, check a fault, a treat for the guest. Whoever goes to the room will see it and tick it off.",
    protocolNote: "The cleaning steps are in the protocol above. This is only for extras.",
    emptyTitle: "No pending requests",
    emptyExamples: "For example: “Replace the bathroom light bulb” or “Leave a welcome bottle of wine”.",
    newBtn: "New request",
    qWhat: "What needs doing?",
    whatPlaceholder: "Write it in your own words…",
    suggestions: "Restock coffee and sugar | Replace a light bulb | Check the air conditioning | Leave extra towels | Check the wifi | Welcome treat",
    qWhen: "When?",
    today: "Today",
    tomorrow: "Tomorrow",
    otherDay: "Another day",
    anyDay: "No date",
    atTime: "At a specific time",
    qWho: "Who does it?",
    whoever: "Whoever cleans",
    isUrgent: "It's urgent",
    urgentHint: "It will stand out and be flagged first.",
    urgent: "Urgent",
    preview: "“{what}” · {when} · {who}",
    cancel: "Cancel",
    save: "Save request",
    showDone: "Show {count} done | Show {count} done",
    hideDone: "Hide done",
    confirmDelete: "Delete the request “{what}”?",
  },

  priority: {
    low: "Basse",
    normal: "Normale",
    high: "Haute",
    urgent: "Urgente",
  },

  roles: {
    limpieza: "Ménage",
    mantenimiento: "Maintenance",
    propietario: "Propriétaire",
  },

  assignee: {
    assigned: "Attribué",
    all: "Tout le monde",
  },
};
